import { find, propEq, ap, pipe, map, filter, ifElse, append, identity, either, any } from 'ramda'
import { propIsFalsy, cReduce, isTruthy } from '@v/util/briqRamdaExt.js'

const findByKeyIn = arr => key => find(propEq('Key', key), arr)

const hasNoParent = propIsFalsy('ParentKey')
export const parentIsNotAvailable = x => bu => !any(propEq('Key', bu.ParentKey), x)

export const getRootBusinessUnits = x => filter(either(hasNoParent, parentIsNotAvailable(x)))(x)

export function toTreeViewModel(availableBusinessUnits) {
  const getBusinessUnitByKey = findByKeyIn(availableBusinessUnits)
  const convertWith = allBusinessUnits => ({ Key, Name, ChildrenKeys }) => ({
    key: Key,
    name: Name,
    children: cReduce(
      pipe(
        getBusinessUnitByKey,
        ifElse(isTruthy, pipe(convertWith(allBusinessUnits), append), () => identity),
      ),
      [],
      ChildrenKeys,
    ),
  })
  const toTreeStructure = ap(pipe(convertWith, map), getRootBusinessUnits) // ap(f,g)(x) = f(x)(g(x))
  return toTreeStructure(availableBusinessUnits)
}
